<template>
    <div id="about-wrapper" class="generic-wrapper">
        <h1 class="page-title">Quienes Somos</h1>
        <img src="../assets/images/icons/logo-hotel-transparent.png" alt="Logo" id="main-logo">
        <h2 class="page-subtitle">Misión</h2>
        <p class="body-text">Suministrar productos de óptima calidad y prestar
            servicios de atención, buscando un nivel de excelencia en la
            satisfacción de los clientes, mediante el mejoramiento continuo
            de nuestros procesos, y la capacitación constante, formando un
            recurso humano con las más altas competencias y completamente
            comprometido con la visión y valores de nuestra empresa.
        </p>

        <h2 class="page-subtitle">Visión</h2>
        <p class="body-text">
            Consolidarnos y ser reconocidos como uno de los establecimientos
            de mayor aceptación en cuanto a calidad de servicios ofertados
            se refiere, atreves del trabajo en equipo, el compromiso
            personal y empresarial, capacitando constantemente a nuestros
            empleados, fomentando el liderazgo y la pasión por la excelencia.
        </p>
    </div>
</template>

<script>
    export default {
        name: "About"
    }
</script>

<style scoped>
    #main-logo {
        width: 50%;
        margin: auto;
        display: block;
    }
</style>